type CheckmarkWithBackgroundIconProps = {
  color: string;
  size?: string;
};

export const CheckmarkWithBackgroundIcon = ({
  color,
  size = "28",
}: CheckmarkWithBackgroundIconProps) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 28 28"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g>
      <path
        d="M10 3h12a4 4 0 0 1 4 4v12a4 4 0 0 1-4 4H10a4 4 0 0 1-4-4V7a4 4 0 0 1 4-4z"
        fill={color}
      />
    </g>
    <path
      d="M13.433 15.881 11.4 14.088a.439.439 0 0 1-.051-.613.501.501 0 0 1 .369-.19.514.514 0 0 1 .394.144l1.677 1.5 6-5.356a.554.554 0 0 1 .664.042.419.419 0 0 1 .047.593l-6.353 5.673a.523.523 0 0 1-.712 0h-.002z"
      fill="#fff"
    />
    <defs>
      <filter id="075kqwryna" x="0" y="0" width={size} height={size}>
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dy="3" />
        <feGaussianBlur stdDeviation="3" />
        <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.161 0" />
        <feBlend
          in2="BackgroundImageFix"
          result="effect1_dropShadow_205_32222"
        />
        <feBlend
          in="SourceGraphic"
          in2="effect1_dropShadow_205_32222"
          result="shape"
        />
      </filter>
    </defs>
  </svg>
);
